
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiUnacknowledged as ObiUnacknowledgedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-unacknowledged.js';
 
 
 

 
 export const ObiUnacknowledged = createComponent({
   react: React,
   tagName: 'obi-unacknowledged',
   elementClass: ObiUnacknowledgedElement,
   events: {
     
   }
  });
 
 